import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d49d280"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "label" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "value" }
const _hoisted_4 = { class: "ip-select-box-empty" }
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = ["innerHTML"]

import { computed, reactive, ref, watch } from 'vue';
import { Select, Modal, message } from 'ant-design-vue';
import { useVueI18n } from '@/hooks';

type SelectOptions = { label: string; value: string }[];
export type IpItem = {
  service: string;
  domain: string;
  ipArea: string;
  ip: string;
  ipId: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'IpSelect',
  props: {
    domainList: {},
    localList: {},
    disableList: {},
    transformIpList: {},
    orgId: {},
    value: {}
  },
  emits: ['update:value'],
  setup(__props: any, { emit: emits }) {

const props = __props;

const { t } = useVueI18n();


const ipData = reactive({
  service: '3',
  domain: undefined as string | undefined,
  ipArea: undefined as string | undefined,
  ip: undefined as string | undefined,
});

const ipList = computed(() => {
  if (props.transformIpList[ipData.ipArea!]) {
    return props.transformIpList[ipData.ipArea!].map(item => {
      return {
        label: item,
        value: item,
        disabled: props.disableList.includes(item),
      };
    });
  }
  return [];
});
const localChange = () => {
  ipData.ip = '';
};

watch(
  () => ipData,
  () => {
    emits('update:value', ipData);
  },
  {
    deep: true,
    immediate: true,
  },
);

watch(
  () => props.transformIpList,
  () => {
    ipData.domain = undefined;
    ipData.ip = undefined;
    ipData.ipArea = undefined;
  },
  {
    immediate: true,
    deep: true,
  },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: require('@/assets/bill/a-svg.svg'),
        alt: ""
      }, null, 8, _hoisted_2),
      _createTextVNode(" IP ")
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(Select), {
        value: ipData.domain,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((ipData.domain) = $event)),
        options: _ctx.domainList,
        style: {"width":"158px"},
        placeholder: "Domain",
        bordered: false,
        "dropdown-match-select-width": false
      }, {
        notFoundContent: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("img", {
              src: require('@/assets/bill/no-data.png'),
              alt: ""
            }, null, 8, _hoisted_5),
            _createElementVNode("p", null, [
              _createTextVNode(_toDisplayString(_ctx.$t('aws.nodata')) + " ", 1),
              _hoisted_6,
              _createElementVNode("span", {
                innerHTML: 
                _ctx.$t('aws.jumpEmail', {
                  orgid: _ctx.orgId,
                })
              
              }, null, 8, _hoisted_7)
            ])
          ])
        ]),
        _: 1
      }, 8, ["value", "options"]),
      _createVNode(_unref(Select), {
        value: ipData.ipArea,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((ipData.ipArea) = $event)),
        options: _ctx.localList,
        style: {"width":"126px"},
        placeholder: "IP geolocation",
        bordered: false,
        onChange: localChange
      }, null, 8, ["value", "options"]),
      _createVNode(_unref(Select), {
        value: ipData.ip,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((ipData.ip) = $event)),
        options: ipList.value,
        style: {"width":"126px"},
        placeholder: "IP address",
        bordered: false
      }, null, 8, ["value", "options"])
    ])
  ], 64))
}
}

})